import { service } from "."

export default {
  googleLogin: (data) => service.post("/protected", data),
  login: (data) => service.post("/auth/visitor/login", data),
  authCreateVerfication: (data) => service.post("/visitors/addverify", data), //reqBody {verifycode, email}
  authEmailVerfication: (data) => service.post("/auth/email-verify", data), //reqBody {verifycode, email,password}
  create: (data) => service.post("/auth/email-reset", data),
  authRegister: (data) => service.post("/auth/email-login", data),
  update: (id, data) => service.post(`/visitors/${id}`, data),
  getCreditionals: (id) => service.get(`/regions/web/${id}`),
}
